import { isPlatformAXA } from 'utils/showDetails';

export const isShareClassVisible = () => !isPlatformAXA;
